import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";

import { Layout } from "../../components/layout";
import { NewsEventsItemsGroup } from "../../components/news-events-items-group";
import { get } from "../../common/request";
import { APIS } from "../admin/common";
import dayjs from "dayjs";

export interface MainProps {}

export function Main(props: MainProps) {
  const [items, setItems] = useState([]);
  const type = "news-events";

  useEffect(() => {
    get(APIS.PROJECT_LIST_SIMPLIFIED, { type }).then((res) => {
      setItems(
        res.data.map((item) => ({
          title: item.title,
          time: dayjs(item.createdAt).format("YYYY-MM-DD"),
          image: item.coverImageUrl,
          link: item.externalLinkUrl || `/article.html?id=${item.id}`
        }))
      );
    });
  }, []);

  return (
    <Layout>
      <Container>
        <NewsEventsItemsGroup items={items} showLoadMore={false} />
      </Container>
    </Layout>
  );
}
